import { getTimeAtMidnight } from '../libraries/HelperFunctions';
import { collection, addDoc, query, where, getDocs, orderBy, doc, updateDoc, deleteDoc } from "firebase/firestore";
import { appointment_path, name, schedule_path } from "./login"
import { db } from "./firebase"
import { getPatient, createPatient } from "./patient_functions"
//__________________APPOINTMENT FUNCTIONS (CRUD OPERATIONS)____________________

/**
 * get appointments for a given cr number
 * @param {object} cr - Patient's ID number
 * @returns {Array} Array with all the appointment objects of a certain patient
 */
 export function getAppointments(cr) {

    return new Promise(async (resolve, reject) => {
        // Checking if patient is registered in system.
        let patientRegistered = await getPatient(cr)
        if (!patientRegistered) {
            alert(`Patient with ID ${cr} is not registered.`)
            resolve(false)
            return
        }
        // Querying all the documents in which the field cr meets the cr passed by us and ordering it by date
        const q = query(collection(db, appointment_path), where("cr", "==", cr), orderBy("date", "desc"));
        // getting the documents specified in q.
        const querySnapshot = await getDocs(q);
        // appointmentList will contain all the appointment objects
        let appointmentList = [];
        querySnapshot.forEach((doc) => {
            // Appending the all the appointment objects queried to appointmentList
            appointmentList.push(doc.data())
        });
        console.log(`Appointments ${appointmentList}`)
        // Resolving premise, since getAppointments(cr) is an async function
        resolve(appointmentList);

    })
}



/**
 * Creates a new treatment plan for a patient.
 * Assumes patient already exists since this is validated in RadiationPlanning submit button.
 * @param {RTPAppointment} treatmentPlan 
 * @returns {void} Nothing is returned.
 */
export async function newTreatmentPlan(treatmentPlan) {
    const physicianRef = collection(db, appointment_path);
    const newTreatmentPlan = await addDoc(physicianRef, {
        cr: treatmentPlan.cr,
        date: treatmentPlan.date,
        registrationTime: (new Date).getTime(),
        uniqueAppointmentId: "",
        codes: treatmentPlan.codes,
    })
    await updateDoc(newTreatmentPlan, {
        uniqueAppointmentId: newTreatmentPlan.id
    });
}



/**
 *  Creates new appointment
 * @param {object} apt - Appointment object containing diagnosis, cr, patientType, aptType, endTime, travel, aptLength, date, code, uniqueAppointmentId
 * @returns {void} Nothing is returned
 */
export async function newAppointment(apt) {
    console.log(`Patient ID Number: ${apt.cr}`)
    let uniquePatientId = await getPatient(apt.cr).then(x => x.uniquePatientId);
    const physiciansRef = collection(db, appointment_path); // removed await
    console.log('db', db)
    console.log('path', appointment_path)
    // Adding new document containing the properties below to the user's/physician's collection
    const newAppointment = await addDoc(physiciansRef, {
        //MATTERS A LOT
        diagnosis: apt.diagnosis,
        cr: String(apt.cr),
        patientType: apt.patientType,
        aptType: apt.aptType,
        time: apt.time,
        billingTime: apt.billingTime,
        length: apt.length,
        date: apt.date,
        codes: apt.codes,
        wasAssessedForHospitalAdmission: apt.wasAssessedForHospitalAdmission,
        userSubmittiedCustomCodes: apt.userSubmittedCustomCodes,
        patientName: apt.patientName,
        seenAnotherDoctor: apt.seenAnotherDoctor,
        price:apt.price,
        // hasReferal: apt.hasReferral, don't need, referall only relevant to current apt not previous
        uniqueAppointmentId: "", //Adam is messing around in here
        registrationTime: (new Date).getTime(),
        specialVisit: apt.specialVisit,
        firstPersonSeen: apt.firstPersonSeen,
        performedTravel: apt.performedTravel,
        sacrificeOfOfficeHours: apt.sacrificeOfOfficeHours,
        uniquePatientId: uniquePatientId,
        noShow: false,
    })
    // Update the document with the Firebase-generated ID as uniquePatientID
    await updateDoc(newAppointment, {
        uniqueAppointmentId: newAppointment.id
    });

    console.log('time', (new Date).getTime())
    // logging on console the path to the new doc.
    console.log(`Your appointment was created at ${newAppointment.path}`);
    console.log(`Codes billed ${apt.codes}`);
    console.log(apt.billingTime)

}



/**
 * @param {String} aptDate - pass in a date string
 * @returns {Promise<number>} The number of appointments the physician had on the given date.
 */
 export async function numberOfAppointmentsAtGivenDate(date) {
    try {
        const appointmentList = await getAppointmentsForDate(date);
        return appointmentList.length;
    } catch (error) {
        console.error("Error in getting number of appointments:", error);
        throw error; // or handle it as per your application's error handling policy
    }
}



/**
 * Returns appointment for the given date
 * @param {String} aptDate - pass in a date string
 * @returns {Array} collectrion of appointments
 */
export async function getAppointmentsForDate(aptDate) {
    const timeAtMidnight = getTimeAtMidnight(new Date(aptDate));
    const q = query(collection(db, appointment_path),
        where("date", "==", aptDate),
        orderBy("registrationTime", "desc"))
    const querySnapshot = await getDocs(q);
    let appointmentList = [];
    querySnapshot.forEach((doc) => {
        appointmentList.push(doc.data())
    })
    return appointmentList;
}



/**
 * Retrieves and filters appointments for a given date that have non-empty billing codes.
 *
 * @param {String} aptDate - The date for which to retrieve appointments. Can be a Date object or a string.
 * @returns {Promise<Array>} A promise that resolves to an array of appointments with non-empty billing codes.
 */

export async function billedAppointmentsForGivenDay(aptDate) {
    let appointments = await getAppointmentsForDate(aptDate);
    let billedAppointments = [];

    for (const appointment of appointments) {
        if (appointment.codes && appointment.codes.length > 0) {
            billedAppointments.push(appointment);
        }
    }
    return billedAppointments;
}




/**
 * Retrieves a single appointment by its unique ID.
 * @param {string} uniqueId - The unique identifier for the appointment.
 * @returns {Promise<Object>} A promise that resolves to the appointment object.
 */
export function getAppointmentById(uniqueId) {
    return new Promise(async (resolve, reject) => {
        const q = query(collection(db, appointment_path), where("uniqueAppointmentId", "==", uniqueId))
        const querySnapshot = await getDocs(q);
        let appointmentList = [];
        querySnapshot.forEach((doc) => {
            appointmentList.push(doc.data())
        })
        console.log(appointmentList, "fneffer fneffer")
        resolve(appointmentList[0]) // probably more elegant way to do this
    });
}



/**
 * Edits an appointment
 * @param {object} appointment - The fields to be updated
 * @returns {void} doesn't return anything
 */
export async function updateAppointment(appointment) {

    //NOTE: ALL THE APPOINTMENTS HAVE A uniqueAppointmentId that no other has

    // querying all documents matching our random generated appointment id
    const q = query(collection(db, appointment_path), where('uniqueAppointmentId', '==', appointment.uniqueAppointmentId));
    const querySnapshot = await getDocs(q);

    // if there's exactly one documents update data, if the id's match, otherwise alert
    const snap = '';
    if (querySnapshot.size == 1) {
        const snap = querySnapshot.docs[0];
        const snapId = snap.ref.id;
        console.log(snapId);

        const docRef = doc(db, appointment_path, snapId);
        const scheduleRef = doc(db, schedule_path, snapId);


        // Updating document
        try{
            updateDoc(docRef, appointment);
            updateDoc(scheduleRef, {
                billed: true,
                codes: appointment.codes
            });

        }
        catch (error){
            alert(`Error! Please contact admin@verusamb.com for 24/7 support.`)
            console.log(`error in updateAppointment(): ${JSON.stringify(error)})`)
        }
    }
    else {
        alert("Something went wrong! Contact support@verusamb.com for support");
    }
}



/**
 * Deletes a certain appointment 
 * @param {object} chosenApt - Appointment object
 * @returns {void} doesn't return anything
 */
export async function deleteAppointment(chosenApt) {
    let whichSchedule;
    if (chosenApt.uniqueScheduleId){
        whichSchedule = chosenApt.uniqueScheduleId;
    }
    else if(chosenApt.uniqueAppointmentId){
        whichSchedule = chosenApt.uniqueAppointmentId;
    }

    const appointmentCollection = query(collection(db, appointment_path), where('uniqueAppointmentId', '==', whichSchedule));
    const scheduleCollection = query(collection(db, schedule_path), where('uniqueScheduleId', '==', whichSchedule));
    
    const querySnapshotAppointment = await getDocs(appointmentCollection);
    const querySnapshotSchedule = await getDocs(scheduleCollection);
    if (querySnapshotAppointment.size == 1) {
        const snapAppointment = querySnapshotAppointment.docs[0];
        const snapAppointmentId = snapAppointment.ref.id;
        const appointmentDocRef = doc(db, appointment_path, snapAppointmentId);

        // Deleting document
        deleteDoc(appointmentDocRef)
            .then(appointmentDocRef => {
                console.log("Appointment document deleted.")
            })
            .catch(error => {
                console.log(error);
            });
    }

    if (querySnapshotSchedule.size == 1) {

        const snapSchedule = querySnapshotSchedule.docs[0];

        const snapScheduleId = snapSchedule.ref.id;

        const scheduleDocRef = doc(db, schedule_path, snapScheduleId)

        deleteDoc(scheduleDocRef)
            .then(scheduleDocRef => {
                console.log("Schedule document deleted.")
            })
            .catch(error => {
                console.log(error);
            }
            );
    }
}



/**
 * Return the number of a points within a time and date constraint.
 * @param {object} date - pass in a date object
 * @param {int} startTime - first time constraint
 * @param {int} startTime - second time constraint
 * @returns {int} the number of appointments the physician had in the given date.
 */
export function getAppointmentsAtGivenTime(date, startTime, endTime) {
    return new Promise(async (resolve, reject) => {
        // Querying all the documents that the date field meets the date parameter
        const q = query(collection(db, appointment_path), where("date", "==", date), where("billingTime", ">=", startTime), where("billingTime", "<", endTime));
        const querySnapshot = await getDocs(q);
        // appointmentList will contain all the appointment objects
        let appointmentList = [];

        querySnapshot.forEach((doc) => {
            // Appending the all the appointment objects queried to appointmentList
            appointmentList.push(doc.data())
        });
        // returning the length of the list/how many appointments happened that day
        resolve(appointmentList.length);
    })
}




/**
 * Sets an appointment as no show.
 * @param {object} apt - Appointment object containing apt information.
 * @returns {Promise<void>} A promise that resolves when the operation is complete.
 */
 export async function setNoShow(apt) {
    try {
        let uniquePatientId = await getPatient(apt.cr);

        if (!uniquePatientId) {
            let patientData = {
                cr: String(apt.cr),
                dateOfBirth: apt.dateOfBirth,
                registrationTime: (new Date()).getTime(),
                name: apt.name,
                diseases: [], // array of objects
            };
            await createPatient(patientData);
            uniquePatientId = await getPatient(apt.cr);
        }
        if (uniquePatientId && uniquePatientId.uniquePatientId) {
            uniquePatientId = uniquePatientId.uniquePatientId;

            const scheduleRef = doc(db, schedule_path, apt.uniqueScheduleId);
            let noShowValue = await getAppointmentById(apt.uniqueScheduleId).then(x => x.noShow);
            if (noShowValue == null){
                noShowValue = true;
            }
            else {
                noShowValue = !noShowValue
            }

            const appointmentRef = doc(db, appointment_path, apt.uniqueScheduleId); 
            await updateDoc(appointmentRef, {
                noShow: noShowValue,
                uniquePatientId: uniquePatientId,
            });


            await updateDoc(scheduleRef, {
                noShow: noShowValue,
                uniquePatientId: uniquePatientId,
            });
            console.log(`Updated noShow to: ${noShowValue}`)
        } else {
            console.error("Unique patient ID not found");
            throw new Error("Unique patient ID not found");
        }
    } catch (error) {
        console.error("Error setting no-show:", error);
        throw error;
    }
}

